import {
  Configuration,
  UserApi,
  type CurrentUser,
  type RequestGoogleAuthFinish,
} from '@/infrastructure/api/client_typescript';
import { TokenStore } from '@/infrastructure/storage/TokenStore';

export class AuthService {
  private userApi: UserApi;

  constructor(
    apiBaseUrl: string,
    private tokenStore: TokenStore
  ) {
    const config = new Configuration({
      basePath: apiBaseUrl,
    });

    this.userApi = new UserApi(config);
  }

  async signInWithPassword(login: string, password: string) {
    try {
      const response = await this.userApi.signInWithPassword({
        username: login,
        password: password,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getCurrentUser(): Promise<CurrentUser> {
    const token = this.tokenStore.getAccess();
    if (!token) {
      throw new Error('Access token not found');
    }

    try {
      const response = await this.userApi.getCurrentUser({
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  logout() {
    this.tokenStore.clearAll();
  }

  async startGoogleAuth() {
    const response = await this.userApi.startGoogleAuth();
    return response.data;
  }

  async finishGoogleAuth(params: RequestGoogleAuthFinish) {
    const response = await this.userApi.finishGoogleAuth(params);
    return response.data;
  }
}
